export const IdentityRegex = /^[A-z0-9]*$/;

export function isIdentityValid(identity = '') {
  return identity && IdentityRegex.test(identity);
}
